// Minimal runtime stubs for @supabase/auth-js optional ./lib/types
// Only values used at runtime in the bundle should be exported here.
export const SIGN_OUT_SCOPES = ['global'];

